import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "primaryToggle",
    "secondaryToggle"
  ]

  toggle() {
    const isPrimaryChecked = this.primaryToggleTarget.checked

    this.secondaryToggleTargets.forEach(toggle => {
      if (isPrimaryChecked && toggle.disabled) {
        toggle.disabled = false
      }

      toggle.checked = isPrimaryChecked
    })
  }
}
